import en from './translations.en';

export default {
  en
};


// WEBPACK FOOTER //
// ./src/constants/translations.js